import type {
    CreateRetainerAgreement,
    RetainerAgreement,
    RetainerAgreementWithFileDetails,
    UpdateRetainerAgreement,
    VoidRetainer,
} from '@common/types/retainerAgreements';
import axiosInstance from './axiosInstance';

export async function fetchRetainerAgreementsByLawFirm(lawFirmId: number) {
    const response = await axiosInstance.get<RetainerAgreementWithFileDetails[]>(
        `/api/v1/lawfirms/${lawFirmId}/retainer-agreements`,
    );
    return response.data;
}

export async function createRetainerAgreement(data: CreateRetainerAgreement) {
    const response = await axiosInstance.post<RetainerAgreement>(
        '/api/v1/retainer-agreement',
        data,
    );
    return response.data;
}

export async function modifyRetainerAgreement(data: UpdateRetainerAgreement, id: number) {
    const response = await axiosInstance.put<RetainerAgreement>(
        `/api/v1/retainer-agreement/${id}`,
        data,
    );
    return response.data;
}

export async function deleteRetainerAgreement(id: number) {
    return axiosInstance.delete<null>(`/api/v1/retainer-agreement/${id}`);
}

export async function voidRetainerAgreement(payload: VoidRetainer) {
    await axiosInstance.post<null>('/api/v1/retainer-agreement/void', payload);
}
